import { Dispatch } from 'react'
import { PointrThemedNavbarState } from './store/State'

import { setMenuAnchor, setUserActionsMenuAnchor, PointrThemedNavbarAction } from './store/Actions'

export default class PointrThemedNavBarService {
  static setMenuAnchor(_state: PointrThemedNavbarState, dispatch: Dispatch<PointrThemedNavbarAction>) {
    return (anchor: any) => {
      dispatch(setMenuAnchor(anchor))
    }
  }

  static setUserActionMenuAnchor(_state: PointrThemedNavbarState, dispatch: Dispatch<PointrThemedNavbarAction>) {
    return (anchor: any) => {
      dispatch(setUserActionsMenuAnchor(anchor))
    }
  }
}
